import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { SaleDocumentKind } from '@skylab-shared/dataModel';

export type OrderKindItem = Omit<OrderKindInternalItem, 'version'>;

type OrderKindInternalItem = {
	defaultDocumentToIssue: SaleDocumentKind;
	defaultVatRateId: number;
	adjustment: boolean;
	name: string;
	version: string;
};

export class OrderKindQuery extends Query<OrderKindItem[]> { }

export class OrderKindQueryHandlerBase implements QueryHandler<OrderKindQuery, OrderKindItem[]> {
	private static Url = TaggedUrl.join('orders/kinds', [Tags.Api]);

	public constructor(private readonly http: HttpService) { }

	public async handleAsync(_: OrderKindQuery): Promise<OrderKindItem[]> {
		const { data } = await this.http.get<{ items: OrderKindInternalItem[]; }>(OrderKindQueryHandlerBase.Url);
		return data.items.map(i => ({
			defaultDocumentToIssue: i.defaultDocumentToIssue,
			defaultVatRateId: i.defaultVatRateId,
			adjustment: i.adjustment,
			name: i.name
		}));
	}
}
